/**
 * Bu doküman PANEL mi, yoksa PUBLIC bir gömme yüzeyi mi (widget iframe'i / hosted storefront)?
 *
 * NEDEN GEREKLİ: gömme yüzeyleri panelle AYNI origin'de çalışır → AYNI localStorage. Oradaki
 * herhangi bir 401, ortak `token`/`refreshToken` anahtarlarını siler ve `LogoutReducer` →
 * `broadcastAuth('logout')` zincirini tetikler; storage olayı panelin AÇIK SEKMESİNE ulaşır ve
 * kullanıcı login ekranına düşer. Panelde widget önizlemesi açınca birebir bu yaşandı; aynı şey
 * partner kendi sitesini panel açıkken ziyaret ettiğinde de oluyordu (önizleme bunu görünür kıldı).
 *
 * Not: storefront'un kendi subdomain'i (acente.tourzone.com) FARKLI origin'dir, ayrı localStorage
 * kullanır — bu yüzden yalnız panel host'undaki yollar ve iframe bağlamı kontrol edilir.
 */
export const isGuestSurface = () => {
    try {
        const p = (window.location && window.location.pathname) || ''
        if (/^\/widget\//.test(p) || /^\/store\//.test(p)) return true
        // Panel hiçbir zaman iframe içinde açılmaz; iframe'deysek gömme bağlamındayız.
        return window.top !== window.self
    } catch (e) {
        // cross-origin window.top erişimi → kesinlikle iframe içindeyiz
        return true
    }
}
